module.exports = __webpack_public_path__ + "img/icon-auth.69a63200.svg";